module.exports = __webpack_public_path__ + "img/BB.3fb12ea5.svg";